/* GH-1133 S5 (§2.0 C7, §2.2): the thin free-preview notice in the
   BillingStateBanner slot on every allowed page except /app (the board
   already explains the offer) and the reveal. Collapsible for the session. */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFreePreview } from '../../contexts/FreePreviewContext.jsx';
import { freePublishingState } from '../../lib/freePublishing.js';

const HIDDEN_KEY = 'dathent.freePreview.stripHidden';

function readHidden() {
  try { return window.sessionStorage.getItem(HIDDEN_KEY) === '1'; } catch { return false; }
}

export default function PreviewStrip() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const freePreview = useFreePreview();
  const [hidden, setHidden] = useState(readHidden);
  if (!freePreview.active || hidden || freePublishingState(freePreview.entitlements)) return null;
  if (pathname === '/app' || pathname === '/app/' || pathname.startsWith('/app/reveal/')) return null;
  const hide = () => {
    try { window.sessionStorage.setItem(HIDDEN_KEY, '1'); } catch { /* per-session convenience */ }
    setHidden(true);
  };
  return (
    <section className="card flb-banner fp-strip" role="note">
      <div className="flb-msg">{t('freePreview.stripText')}</div>
      <div className="flb-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={() => freePreview.openTrialWall('cta', { from: 'strip' })}>
          {t('freePreview.stripCta')}
        </button>
        <button type="button" className="btn btn-ghost btn-sm" aria-label={t('common.close')} onClick={hide}>×</button>
      </div>
    </section>
  );
}
